import React from "react";
import { Query, QueryResult } from "react-apollo";
import { Topic, TopicInfo } from "../../fragments/topic";
import gql from "graphql-tag";

const searchTopicsQuery = gql`
  query searchTopicsQuery($offset: Int, $keyword: String, $type: String) {
    topics: topics(type: $type, offset: $offset, keyword: $keyword) {
      ...TopicInfo
    }
  }
  ${TopicInfo}
`;

interface SearchTopicsData {
  topics: Topic[];
}

type SearchTopicsQueryResults = QueryResult<SearchTopicsData>;

interface SearchTopicsProps {
  type: string;
  query: string;
  children: (queryResult: SearchTopicsQueryResults) => React.ReactNode;
}

const SearchTopics: React.FC<SearchTopicsProps> = (props) => {
  const { children, type, query } = props;
  return (
    <Query
      query={searchTopicsQuery}
      fetchPolicy="network-only"
      variables={{ keyword: query, type }}
    >
      {(queryResult: SearchTopicsQueryResults) => {
        return children(queryResult);
      }}
    </Query>
  );
};

export default SearchTopics;
